import { useQuery } from 'react-query';

import Header from '../Header';
import Footer from '../Footer';
import OfferTypeConfirm from '../OfferTypeConfirm';
import { StyledAllProducts, StyledWrapper, StyledMain } from './AppSubscribe.styles';
import { getOffers } from '../../lib/apiService';
import { offersUnit } from '../../state';
import { TESTATE } from '../../lib/constants';
import {
  getTestata,
  filterOffersByCodeName,
  transformOnlineStripeOffers,
  getAndSanitizeQS,
  goToHref,
} from '../../lib/utils';
import Faq from '../../components/Faq';
import { offerTypeLabels, faqList } from '../../lib/labels';
import offerSfogliatoreData from '../../data/sfogliatore.json';
import offerCartaData from '../../data/carta.json';

function getCartaURL(params) {
  const searchParams = new URLSearchParams(params);
  const url = new URL(TESTATE[getTestata()].urlPurchaseCarta);
  searchParams.forEach((k, v) => {
    url.searchParams.set(k, v);
  });
  return url.toString();
}

function getSfogliatoreURL(params) {
  const searchParams = new URLSearchParams(params);
  const url = new URL(TESTATE[getTestata()].urlPurchaseSfogliatore);
  searchParams.forEach((k, v) => {
    url.searchParams.set(k, v);
  });
  return url.toString();
}

function getCheckoutURL(params) {
  const searchParams = new URLSearchParams(params);
  searchParams.append('page', 'checkout');
  return `/paywall?${searchParams.toString()}`;
}

function getDigitalOffers(onlineOffers, goToURLParams) {
  const offerOnline = filterOffersByCodeName(
    transformOnlineStripeOffers(onlineOffers),
    getAndSanitizeQS('online'),
  );
  const offerSfogliatore = filterOffersByCodeName(
    offerSfogliatoreData,
    getAndSanitizeQS('sfogliatore'),
  );
  return [
    { ...offerOnline, goTo: goToHref(getCheckoutURL(goToURLParams)) },
    { ...offerSfogliatore, goTo: goToHref(getSfogliatoreURL(goToURLParams)) },
  ];
}

function getAllOffers(onlineOffers, goToURLParams) {
  const digitalOffers = getDigitalOffers(onlineOffers, goToURLParams);
  return [...digitalOffers, { ...offerCartaData, goTo: goToHref(getCartaURL(goToURLParams)) }];
}

function AppSubscribe({ message1, message2, brief, goToURLParams }) {
  const offersQuery = useQuery('offers', getOffers);
  const offers =
    offersQuery.data &&
    (brief
      ? getDigitalOffers(offersQuery.data, goToURLParams)
      : getAllOffers(offersQuery.data, goToURLParams));

  offersQuery.data && offersUnit.dispatch(offersQuery.data);

  return (
    <StyledWrapper hasLightBg={brief}>
      {brief || <Header />}
      <StyledMain>
        <OfferTypeConfirm
          message1={message1 || offerTypeLabels.message1}
          message2={message2 || offerTypeLabels.message2}
        />
        {offersQuery.data && <StyledAllProducts offers={offers} brief={!!brief} />}
      </StyledMain>
      {brief || (
        <>
          <Faq faqList={faqList} />
          <Footer />
        </>
      )}
    </StyledWrapper>
  );
}

export default AppSubscribe;
